namespace Nobox.CRM {
    export interface DealpipelinetypesRow {
        Id?: number;
        stgindex?: number;
        Active?: number;
        Name?: string;
        Description?: string;
        Sequence?: number;
        LegendBlocked?: string;
        LegendDone?: string;
        LegendNormal?: string;
        MailTemplateId?: number;
        Fold?: number;
        RatingTemplateId?: number;
        AutoValidationKanbanState?: number;
        IsClosed?: number;
        UserId?: number;
        CreateUid?: number;
        CreateDate?: string;
        WriteUid?: number;
        WriteDate?: string;
        project_id?: number;
        ProjectName?: string;
    }

    export namespace DealpipelinetypesRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Nobox.Dealpipelinetypes';
        export const lookupKey = 'Nobox.Dealpipelinetypes';

        export function getLookup(): Q.Lookup<DealpipelinetypesRow> {
            return Q.getLookup<DealpipelinetypesRow>('Nobox.Dealpipelinetypes');
        }
        export const deletePermission = 'Deals:Delete';
        export const insertPermission = 'Deals:Modify';
        export const readPermission = 'Deals:View';
        export const updatePermission = 'Deals:Modify';

        export declare const enum Fields {
            Id = "Id",
            stgindex = "stgindex",
            Active = "Active",
            Name = "Name",
            Description = "Description",
            Sequence = "Sequence",
            LegendBlocked = "LegendBlocked",
            LegendDone = "LegendDone",
            LegendNormal = "LegendNormal",
            MailTemplateId = "MailTemplateId",
            Fold = "Fold",
            RatingTemplateId = "RatingTemplateId",
            AutoValidationKanbanState = "AutoValidationKanbanState",
            IsClosed = "IsClosed",
            UserId = "UserId",
            CreateUid = "CreateUid",
            CreateDate = "CreateDate",
            WriteUid = "WriteUid",
            WriteDate = "WriteDate",
            project_id = "project_id",
            ProjectName = "ProjectName"
        }
    }
}
